/**
 ** FAQ Block JS
 **/
document.addEventListener("DOMContentLoaded", function () {
  if (window.__faqInitialized) { return; }

  window.__faqInitialized = true;

  const accordionItems = document.querySelectorAll(".accordion-item");

  accordionItems.forEach((item) => {
    const header = item.querySelector(".accordion-header");
    const content = item.querySelector(".accordion-content");
    const icon = item.querySelector(".plus-minus");
    const startsOpen = item.classList.contains("open");

    header.setAttribute("aria-expanded", startsOpen ? "true" : "false");
    content.toggleAttribute("inert", !startsOpen);

    if (startsOpen) {
      content.style.maxHeight = content.scrollHeight + "px";
      icon.classList.add("toggled");
    }

    header.addEventListener("click", function () {
      const isActive = content.style.maxHeight;

      if (isActive) {
        content.style.maxHeight = null;
        content.setAttribute("inert", "");
        header.setAttribute("aria-expanded", "false");
        icon.classList.remove("toggled");
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
        content.removeAttribute("inert");
        header.setAttribute("aria-expanded", "true");
        icon.classList.add("toggled");
      }
    });
  });
});
